import * as angular from "angular";

angular
  .module('bringoz.admin.scheduling-project', []);
